var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.0623H11V9.06226H9V15.0623ZM10 7.06226C10.2833 7.06226 10.5208 6.96642 10.7125 6.77476C10.9042 6.58309 11 6.34559 11 6.06226C11 5.77892 10.9042 5.54142 10.7125 5.34976C10.5208 5.15809 10.2833 5.06226 10 5.06226C9.71667 5.06226 9.47917 5.15809 9.2875 5.34976C9.09583 5.54142 9 5.77892 9 6.06226C9 6.34559 9.09583 6.58309 9.2875 6.77476C9.47917 6.96642 9.71667 7.06226 10 7.06226ZM10 20.0623C8.61667 20.0623 7.31667 19.7998 6.1 19.2748C4.88333 18.7498 3.825 18.0373 2.925 17.1373C2.025 16.2373 1.3125 15.1789 0.7875 13.9623C0.2625 12.7456 0 11.4456 0 10.0623C0 8.67892 0.2625 7.37892 0.7875 6.16226C1.3125 4.94559 2.025 3.88726 2.925 2.98726C3.825 2.08726 4.88333 1.37476 6.1 0.849756C7.31667 0.324756 8.61667 0.0622559 10 0.0622559C11.3833 0.0622559 12.6833 0.324756 13.9 0.849756C15.1167 1.37476 16.175 2.08726 17.075 2.98726C17.975 3.88726 18.6875 4.94559 19.2125 6.16226C19.7375 7.37892 20 8.67892 20 10.0623C20 11.4456 19.7375 12.7456 19.2125 13.9623C18.6875 15.1789 17.975 16.2373 17.075 17.1373C16.175 18.0373 15.1167 18.7498 13.9 19.2748C12.6833 19.7998 11.3833 20.0623 10 20.0623Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.44933dd7b5a55fed184edc7b704970c4.svg";
export { ForwardRef as ReactComponent };